const letters = [
  {
    beneficiary: {
      benId: "0234",
      name: "Fiston Ntwari",
    },
    letter: {
      type: "forward",
      arrivalDate: "12.Ugushyingo.2020",
    },
  },

  {
    beneficiary: {
      benId: "0256",
      name: "Dukundane daniel",
    },
    letter: {
      type: "forward",
      arrivalDate: "12.Ugushyingo.2020",
    },
  },
  {
    beneficiary: {
      benId: "0355",
      name: "Ntezirizaza erneste",
    },
    letter: {
      type: "reply",
      arrivalDate: "12.Ugushyingo.2020",
    },
  },
];

let beneficiaries = [
  {
    benId: "0638",
    firstName: "Fiston",
    lastName: "Nshimiyandinze",
  },
  {
    benId: "0638",
    firstName: "Fiston",
    lastName: "Nshimiyandinze",
  },
  {
    benId: "0638",
    firstName: "Fiston",
    lastName: "Nshimiyandinze",
  },
];

const roles = [
  { value: "pcd", label: "PCD" },
  { value: "nurse", label: "Ushinzwe ubuzima" },
  { value: "accountant", label: "Umucungamutungo" },
  { value: "teacher", label: "Umwarimu" },
];

const projectStaff = [
  {
    name: "Mugabe Gershom",
    role: "PCD",
    startDate: "12.Nyakanga.2020",
    endDate: "now",
    email: "mugabe@gmail.com",
    tel: "0787776756556/0723446776",
    roleStatusActive: false,
  },
  {
    name: "Hirwa Faustine",
    role: "Ushinzwe ubuzima",
    startDate: "12.Nyakanga.2020",
    endDate: "continuing",
    email: "mugabe@gmail.com",
    tel: "0787776756556/0723446776",
    roleStatusActive: false,
  },
  {
    name: "Munezero gervais",
    role: "Umucungamutungo",
    startDate: "12.Nyakanga.2020",
    endDate: "12.Gicurasi.2021",
    email: "mugabe@gmail.com",
    tel: "0787776756556/0723446776",
    roleStatusActive: true,
  },
];

// select options
const beneficiaryStatus = [
  { value: "ACTIVE", label: "Active" },
  { value: "EXITTED", label: "Exitted" },
];
// for beneficiries table
const beneficiriesData = [
  {
    count: 1,
    benId: "RW0688",
    name: "Ntwari Egide",
    gender: "Gabo",
    birthDate: "12.Nyakanga.2000(20)",
    status: "Aracyafashwa",
  },
  {
    count: 1,
    benId: "RW0688",
    name: "Ntwari Egide",
    gender: "Gabo",
    birthDate: "12.Nyakanga.2000(20)",
    status: "Aracyafashwa",
  },
  {
    count: 1,
    benId: "RW0688",
    name: "Ntwari Egide",
    gender: "Gabo",
    birthDate: "12.Nyakanga.2000(20)",
    status: "Aracyafashwa",
  },
  {
    count: 1,
    benId: "RW0688",
    name: "Ntwari Egide",
    gender: "Gabo",
    birthDate: "12.Nyakanga.2000(20)",
    status: "Aracyafashwa",
  },
];
const academicsMarks = [
  {
    count: 1,
    beneficiary: "RW0688 Ntwari Egide",
    year: "2020 2021",
    term: "Second",
    marks: 80,
    status: "Yaratsinze",
  },
  {
    count: 1,
    beneficiary: "RW0688 Ntwari Egide",
    year: "2020 2021",
    term: "Second",
    marks: 80,
    status: "Yaratsinze",
  },
  {
    count: 1,
    beneficiary: "RW0688 Ntwari Egide",
    year: "2020 2021",
    term: "Second",
    marks: 80,
    status: "Yaratsinze",
  },
  {
    count: 1,
    beneficiary: "RW0688 Ntwari Egide",
    year: "2020 2021",
    term: "Second",
    marks: 80,
    status: "Yaratsinze",
  },
];
const beneficiariesOptions = [];
const Insurances = [{ value: "2000 2021", label: "0438" }];

// select options
const academicTerms = [
  { value: "1", label: "1" },
  { value: "2", label: "2" },
  { value: "3", label: "3" },
];
const beneficiaryInsurances = [
  {
    count: 1,
    beneficiary: "RW0688 Ntwari Egide",
    startDate: "12.Mata.2020",
    endDate: "12.Mata.2020",
    insurance: "Mituelle",
  },
];

const fundData = [
  {
    count: 1,
    beneficiary: "RW0688 Ntwari Egide",
    fund: 2000,
    neededAmount: 15000,
    startDate: "12.Mata.2020",
    endDate: "12.Mata.2020",
    insurance: "Mituelle",
    status: "Yakwivuza",
  },
  {
    count: 1,
    beneficiary: "RW0688 Ntwari Egide",
    fund: 2000,
    neededAmount: 15000,
    startDate: "12.Mata.2020",
    endDate: "12.Mata.2020",
    insurance: "Mituelle",
    status: "Yakwivuza",
  },
  {
    count: 1,
    beneficiary: "RW0688 Ntwari Egide",
    fund: 2000,
    neededAmount: 15000,
    startDate: "12.Mata.2020",
    endDate: "12.Mata.2020",
    insurance: "Mituelle",
    status: "Yakwivuza",
  },
];
const insurances = [{ name: "MITUELLE" }, { name: "RAMA" }, { name: "MMI" }];
const assocciations = [
  {
    name: "Twitezimbere",
    target: "Kubitsa no kugurizanya",
    earnedAmount: 20000,
    members: [
      {
        name: "0634 Hirwa blessing",
        startDate: "09.Nyakanga.2020",
        endDate: "09.Mata.2021",
        shareToAmember: 10,
        inPosition: {
          name: "Karera Luke",
          role: "Umubyeyi",
        },
      },
      {
        name: "0634 Hirwa blessing",
        startDate: "09.Nyakanga.2020",
        endDate: "09.Mata.2021",
        shareToAmember: 10,
        inPosition: {
          name: "Karera Luke",
          role: "Umubyeyi",
        },
      },
    ],
  },
  {
    name: "Twitezimbere",
    target: "Kubitsa no kugurizanya",
    earnedAmount: 20000,
    members: [
      {
        name: "0634 Hirwa blessing",
        startDate: "09.Nyakanga.2020",
        endDate: "09.Mata.2021",
        shareToAmember: 10,
        inPosition: {
          name: "Karera Luke",
          role: "Umubyeyi",
        },
      },
      {
        name: "0634 Hirwa blessing",
        startDate: "09.Nyakanga.2020",
        endDate: "09.Mata.2021",
        shareToAmember: 10,
        inPosition: {
          name: "Karera Luke",
          role: "Umubyeyi",
        },
      },
    ],
  },
];
const selectedAssocciation = {
  name: "Twitezimbere",
  beneficiaries: [
    {
      count: 1,
      beneficiary: "RW0688 Ntwari Egide",
      status: "Aracyarimo",
      startDate: "12.Mata.2020",
      endDate: "12.Mata.2020",
      share: 14,
    },
  ],
  target: "Kubitsa no kugurizanya",
  description:
    "Hari igihe umuntu agira igitekerezo ariko kugishyira mu bikorwa bikamugora. Yagifatanya na bagenzi be nk’itsinda bikoroha, dore ko abishyize hamwe nta kibananira nk’uko umugani nyarwanda ubivuga. Mu itsinda rero ngo guhuza intumbero no gushyira hamwe imbaraga ni ibanga ryo kugera kure",
  share: 20,
  site: "Gishali mugusha",
  projects: [
    {
      title: "Kubaka uturima twigikoni",
    },
    {
      title: "Kubaka uturima twigikoni",
    },
  ],
  property: [
    {
      name: "112000 frw",
    },
    {
      name: "Ihene(5) frw",
    },
  ],
};
const residences = [{ name: "Gishali mugusha" }, { name: "Gishali bwinsanga" }];

const residenceData = [
  {
    count: 1,
    beneficiary: "RW0688 Ntwari Egide",
    residence: "Gishali mugusha",
    startDate: "12.Mata.2020",
    endDate: "12.Mata.2020",
    status: "Afite inzu",
  },
];
const categoris = [{ name: "1" }, { name: "2" }];
const categoryData = [
  {
    count: 1,
    beneficiary: "RW0688 Ntwari Egide",
    hhdName: "Fiston Hagena",
    hhdId: 118223232332233,
    startDate: "12.Mata.2020",
    endDate: "12.Mata.2020",
    category: 1,
    familyMembers: 5,
  },
];
const selectedStock = {
  name: "Twitezimbere",
  items: [
    {
      count: 1,
      name: "Ibikombe",
      amount: 40,
      status: "Cyararangiye",
      owner: "Umushinga",
      time: "12 Mata 2020",
    },
  ],
  stockOwner: "Umucungamutungo",
  description:
    "Hari igihe umuntu agira igitekerezo ariko kugishyira mu bikorwa bikamugora. Yagifatanya na bagenzi be nk’itsinda bikoroha, dore ko abishyize hamwe nta kibananira nk’uko umugani nyarwanda ubivuga. Mu itsinda rero ngo guhuza intumbero no gushyira hamwe imbaraga ni ibanga ryo kugera kure",
};
const selectedEconomy = {
  name: "Imitungo yabagenerwabikorwa",
  benProperties: [
    {
      count: 1,
      beneficiary: "RW0688 Ntwari Egide",
      properties: [
        {
          name: "Inzu",
        },
        {
          name: "Akarima k'igikoni",
        },
      ],
    },
  ],
  stockOwner: "Abagenerwabikorwa",
  description:
    "Hari igihe umuntu agira igitekerezo ariko kugishyira mu bikorwa bikamugora. Yagifatanya na bagenzi be nk’itsinda bikoroha, dore ko abishyize hamwe nta kibananira nk’uko umugani nyarwanda ubivuga. Mu itsinda rero ngo guhuza intumbero no gushyira hamwe imbaraga ni ibanga ryo kugera kure",
};
const parents = [
  {
    count: 1,
    beneficiary: "RW0688 Ntwari Egide",
    mother: "Mahoro jane",
    father: "Nkusi Gilbert",
    status: "Bariho",
  },
];
const caregiversData = [
  {
    count: 1,
    beneficiary: "RW0688 Ntwari Egide",
    caregiver: "Ababyeyi",
    startDate: "12.Mata.2020",
    endDate: "12.Mata.2020",
  },
];
const Schools = [
  { name: "Gs Gishali", site: "Bwinsanga mugusha", phone: "078383455" },
  { name: "Gs Gahini", site: "Gahini sector", phone: "078383455" },
];
const beneficiariesSchools = [
  {
    count: 1,
    beneficiary: "RW0688 Ntwari Egide",
    school: "Gs gishali",
    startDate: "12.Mata.2020",
    endDate: "12.Mata.2020",
    status: "Arataha",
  },
];
const events = [
  {
    name: "Isuzuma",
    typeKey: "ISZ",
    startDate: "12 Mata 2020",
    endDate: "12 Mata 2020",
    attendees: [{}, {}],
  },
  {
    name: "Ishuri ryo kwa 6",
    typeKey: "SAT",
    startDate: "12 Mata 2020",
    endDate: "",
    attendees: [{}, {}],
  },
  {
    name: "Gusura abagenerwabikorwa",
    typeKey: "VIS",
    startDate: "12 Mata 2020",
    endDate: "",
    attendees: [{}, {}],
  },
  {
    name: "Inama",
    typeKey: "MEE",
    startDate: "12 Mata 2020",
    endDate: "",
    attendees: [{}, {}],
  },
];
const selectedEvent = {
  name: "Isuzuma 1",
  typeKey: "ISZ",
  attendees: [
    {
      count: 1,
      beneficiary: "RW0645 Ntezi Erneste",
      testDate: "10.Nyakanga.2021",
      testSite: "Rwamagana hospital",
      testedOne: "Niwe",
    },
  ],
  EventType: "Isuzuma",
  startDate: "12 Mata 2020",
  endDate: "12 Nyakanga 2020",
  description:
    "Hari igihe umuntu agira igitekerezo ariko kugishyira mu bikorwa bikamugora. Yagifatanya na bagenzi be nk’itsinda bikoroha, dore ko abishyize hamwe nta kibananira nk’uko umugani nyarwanda ubivuga. Mu itsinda rero ngo guhuza intumbero no gushyira hamwe imbaraga ni ibanga ryo kugera kure",
};

const selectedVisit = {
  name: "Isurwa",
  typeKey: "VIS",
  attendees: [
    {
      count: 1,
      beneficiary: "RW0645 Ntezi Erneste",
      visitDate: "10.Nyakanga.2021",
      visitSite: "Murugo",
    },
  ],
  EventType: "Isuzuma",
  startDate: "12 Mata 2020",
  endDate: "12 Nyakanga 2020",
  description:
    "Hari igihe umuntu agira igitekerezo ariko kugishyira mu bikorwa bikamugora. Yagifatanya na bagenzi be nk’itsinda bikoroha, dore ko abishyize hamwe nta kibananira nk’uko umugani nyarwanda ubivuga. Mu itsinda rero ngo guhuza intumbero no gushyira hamwe imbaraga ni ibanga ryo kugera kure",
};
const selectedSatEvent = {
  name: "Ishuri ryo kuwa 10.Mata.2021",
  attendees: [
    {
      count: 1,
      beneficiary: "RW0645 Ntezi Erneste",
      studyDate: "10.Nyakanga.2021",
      studySite: "Project office",
      status: "Ntiyakererewe",
    },
  ],
  EventType: "Isuzuma",
  EventDate: "",
  description:
    "Hari igihe umuntu agira igitekerezo ariko kugishyira mu bikorwa bikamugora. Yagifatanya na bagenzi be nk’itsinda bikoroha, dore ko abishyize hamwe nta kibananira nk’uko umugani nyarwanda ubivuga. Mu itsinda rero ngo guhuza intumbero no gushyira hamwe imbaraga ni ibanga ryo kugera kure",
};
const selectedMeeting = {
  name: "Inama 10.Mata.2021",
  attendees: [
    {
      count: 1,
      beneficiary: "RW0645 Ntezi Erneste",
      meetingDate: "10.Nyakanga.2021",
      meetingSite: "Project office",
      status: "Ntiyakererewe",
      meetingOne: "Umubyeyi",
    },
  ],
  EventType: "Isuzuma",
  EventDate: "10.Mata.2021",
  description:
    "Hari igihe umuntu agira igitekerezo ariko kugishyira mu bikorwa bikamugora. Yagifatanya na bagenzi be nk’itsinda bikoroha, dore ko abishyize hamwe nta kibananira nk’uko umugani nyarwanda ubivuga. Mu itsinda rero ngo guhuza intumbero no gushyira hamwe imbaraga ni ibanga ryo kugera kure",
};
const funds = [
  {
    name: "Kubakirwa inzu",
    typeKey: "GFT",

    attendees: [{}, {}],
  },
  {
    name: "Kiwshyura ishuri",
    typeKey: "GFT",

    attendees: [{}, {}],
  },
  {
    name: "Noheri",
    typeKey: "FND",

    attendees: [{}, {}],
  },
];
const selectedFund = {
  name: "Kubakirwa inzu",
  receipents: [
    {
      count: 1,
      beneficiary: "RW0645 Ntezi Erneste",
      receiveDate: "10.Nyakanga.2021",
      receiveSite: "Rwamagana hospital",
      fundAmount: 2000,
      benAmount: 10000,
      receivedOne: "Niwe",
    },
  ],

  description:
    "Hari igihe umuntu agira igitekerezo ariko kugishyira mu bikorwa bikamugora. Yagifatanya na bagenzi be nk’itsinda bikoroha, dore ko abishyize hamwe nta kibananira nk’uko umugani nyarwanda ubivuga. Mu itsinda rero ngo guhuza intumbero no gushyira hamwe imbaraga ni ibanga ryo kugera kure",
};
const selectedGift = {
  name: "Kubakirwa inzu",
  receipents: [
    {
      count: 1,
      beneficiary: "RW0645 Ntezi Erneste",
      receiveDate: "10.Nyakanga.2021",
      receiveSite: "Rwamagana hospital",
      giftValue: 10000,
      receivedOne: "Niwe",
    },
  ],

  description:
    "Hari igihe umuntu agira igitekerezo ariko kugishyira mu bikorwa bikamugora. Yagifatanya na bagenzi be nk’itsinda bikoroha, dore ko abishyize hamwe nta kibananira nk’uko umugani nyarwanda ubivuga. Mu itsinda rero ngo guhuza intumbero no gushyira hamwe imbaraga ni ibanga ryo kugera kure",
};
const beneficiaryLetters = [
  {
    count: 1,
    beneficiary: "RW0688 Ntwari Egide",
    date: "01.Nyakanga.2020",
    ticket: 2000,
    letterType: "Urwakirwa",
  },
];
const beneficiaryVisits = [
  {
    count: 1,
    beneficiary: "RW0688 Ntwari Egide",
    date: "01.Nyakanga.2020",
    ticket: 2000,
  },
];
const stocks = [
  {
    name: "Ububiko 1",
    owner: "PRO",
    items: [{}, {}],
  },
  {
    name: "Ububiko 2",
    owner: "PRO",
    items: [{}, {}],
  },
  {
    name: "Imitungo yabagenerwabikorwa",
    owner: "ECO",
    items: [{}, {}],
  },
];
const properties = [{ name: "Inzu" }, { name: "Akarima k'igikoni" }];
const selectedBeneficiary = {
  ident: {
    name: "Muyomba fle",
    benId: "0638",
    birthDate: "12.nyakanga.2001",
    gender: "Gore",
    status: "active",
  },
  caregivers: {
    mother: "Mahoro jane",
    father: "Nkusi Gilbert",
    caregiver: "Ababyeyi",
    status: "Bose bariho",
  },
  academics: {
    school: "Gs gahini",
    class: "S5",
    section: "PCB",
    marks: 70,
  },
  projectsProgram: {
    groupAge: "12 14",
    satStudy: "12.Nyakanga.2021",
    letters: 20,
    funds: 15,
  },
  healthy: {
    test: "12.Mata.2021",
    insurance: "Mituelle",
    division: "2",
    hhd: "Nkusi Gilbert",
  },
  residence: {
    country: "Rwanda",
    province: "Iburasirazuba",
    district: "Rwamagana",
    sector: "Gishari",
    cell: "Bwinsanga",
    village: "Mugusha",
    commonName: "Mugusha",
  },
};
const notifs = [
  {
    source: "Itsinda rishya",
    message: "Handikitswe itsinda twitezimbere",
    time: "Nyakanga 30 - 3:20 pm",
    doneBy: "Fiston fle",
    actionCode: "CREATE",
  },
  {
    source: "Abagenerwabikorwa",
    message: "Umugenerwabikorwa witwa Hagena yasibwe ",
    time: "Nyakanga 30 - 3:40 pm",
    doneBy: "Fiston fle",
    actionCode: "DELETE",
  },
  {
    source: "Itsinda rishya",
    message: "Handikitswe itsinda twitezimbere",
    time: "Nyakanga 30 - 3:20 pm",
    doneBy: "Fiston fle",
    actionCode: "CREATE",
  },
];
export {
  beneficiaries,
  letters,
  roles,
  projectStaff,
  beneficiaryStatus,
  beneficiriesData,
  beneficiariesOptions,
  academicsMarks,
  Insurances,
  academicTerms,
  beneficiaryInsurances,
  fundData,
  insurances,
  assocciations,
  selectedAssocciation,
  residences,
  residenceData,
  categoris,
  categoryData,
  selectedStock,
  selectedEconomy,
  parents,
  caregiversData,
  Schools,
  beneficiariesSchools,
  events,
  selectedEvent,
  selectedSatEvent,
  selectedVisit,
  funds,
  selectedFund,
  selectedGift,
  beneficiaryLetters,
  stocks,
  properties,
  selectedBeneficiary,
  beneficiaryVisits,
  selectedMeeting,
  notifs,
};
